<template>
  <el-row style="height: 100%">
    <el-col :lg="6" :md="7" :sm="8" :xl="4" class="overflow"
            style="padding: 10px;height: 100%;overflow: auto;background-color: rgba(41, 155, 255, .1);">
      <div>选择需要绑定的空间：</div>
      <el-input class="inline-input margin-top-10" v-model="orgName" placeholder="请输入搜索的空间名称" size="mini"
                @change="changeOrgName"/>
      <space-tree-show  @spaceChoose="spaceChoose" ref="org" class="space"/>
    </el-col>
    <el-col :lg="18" :md="16" :sm="16" :xl="20" style="height: 100%;padding: 0 0 5px 40px">
      <el-row class="margin-bottom-10">
        <el-col :lg="12" :md="14" :sm="16" :xl="8">先选择要绑定的设备，在左侧再选择对应的空间：</el-col>
        <el-col :span="8">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的名称" size="mini"
                    @change="changeName"></el-input>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        @selection-change="changeCheckBoxValue"
        border
        height="90%"
        style="width: 100%;">
        <el-table-column
          type="selection"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="设备名称"
          prop="name">
        </el-table-column>
        <el-table-column
          align="center"
          label="所在主机"
          prop="gatewayName">
        </el-table-column>
        <el-table-column
          align="center"
          label="类型"
          prop="typeCnName">
        </el-table-column>
        <el-table-column
          align="center"
          label="品牌"
          prop="brandCnName">
        </el-table-column>
        <el-table-column
          align="center"
          label="型号"
          prop="modelCnName">
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px;margin-bottom:10px;width: 100%;text-align: center;">
        <el-button @touchstart="boundDevices" @click="boundDevices" size="mini">绑定</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import {boundDevices} from "@/network/device-info";

export default {
  name: "BoundDevice",
  components: {SpaceTreeShow},
  inject: ['overflow'],
  mounted() {
    this.overflow()
  },
  props: ['unboundDevice'],
  data() {
    return {
      name: '',
      orgName: '',
      tableData: this.unboundDevice.map(item => ({...item})),
      spaceId: null,
      spaceName: null,
      // 首次进入
      isLoad: true,
      deviceList: []
    }
  },
  methods: {
    // 树形筛选
    changeOrgName() {
      this.$refs.org.changName(this.orgName);
    },
    // 设备筛选
    changeName() {
      if (!this.name) {
        this.tableData = this.unboundDevice.map(item => ({...item}))
        return
      }
      let arr = JSON.parse(JSON.stringify(this.unboundDevice.map(item => ({...item}))))
      let newA = []
      arr.forEach((item, ind) => {
        newA[ind] = item
        if (newA[ind].name.indexOf(this.name) != '-1') {
          newA[ind].children = item.children
        }
      })
      for (let i = newA.length; i--; i > 0) {
        if (!newA[i].children || newA[i].children.length == 0) {
          if (newA[i].name.indexOf(this.name) == '-1') {
            newA.splice(i, 1)
          }
        }
      }
      this.tableData = newA
    },
    changeCheckBoxValue: function (val) {
      this.deviceList = [];
      for (let i = 0; i < val.length; i++) {
        this.deviceList.push(val[i]);
      }
    },
    spaceChoose(spaceInfo) {
      if (this.isLoad == true) {
        this.isLoad = false;
        this.$refs.org.ztreeObj.selectNode([]);
      } else {
        if (spaceInfo.type != 1) {
          this.spaceId = spaceInfo.id;
          this.spaceName = spaceInfo.title;
        } else {
          this.$message.warning('此空间为逻辑空间,无法选择');
          this.spaceId = null;
          this.spaceName = null;
          this.$refs.org.ztreeObj.selectNode([]);
        }
      }
    },
    boundDevices() {
      if (this.deviceList.length < 1) {
        this.$message.warning("请先勾选要绑定的设备!");
      } else {
        if (this.spaceId) {
          this.deviceList.map(item => {
            item.spaceId = this.spaceId;
            item.spaceName = this.spaceName;
          })
        } else {
          this.$message.warning("请先选择要绑定的空间!")
          return;
        }
        boundDevices(this.deviceList).then(res => {
          if (res.code === 0) {
            this.$emit('close')
            this.$message.success("绑定成功!")
          } else {
            this.$message.error("绑定失败!")
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.space {
  margin: 20px 0 10px 20px;
  width: calc(100% - 20);
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}
</style>
